import { createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) => createStyles({
  root: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 60,
    marginBottom: theme.spacing(1),
  },
  caption: {
    marginLeft: theme.spacing(2),
  },
});

export default styles;
